import { Dispatch, useCallback } from "react";
import { Process } from "../../../../api/recipeSimulator";
import {
  ManageRecipeVariantAction,
  ManageRecipeVariantModalKey
} from "./manageRecipeVariantReducer";

export const useManageRecipeVariantDispatch = (
  dispatch: Dispatch<ManageRecipeVariantAction>,
  selectedVariants: any[],
  isAtBottom: boolean
) => {
  const setModal = useCallback(
    (modal: ManageRecipeVariantModalKey, open: boolean) =>
      dispatch({ type: "SET_MODAL", modal, open }),
    [dispatch]
  );

  const setVisibleModal = useCallback(
    (open: boolean) => setModal("visibleModal", open),
    [setModal]
  );
  const setVisibleUpdateModal = useCallback(
    (open: boolean) => setModal("visibleUpdateModal", open),
    [setModal]
  );
  const setVisibleRecipeUpdateModal = useCallback(
    (open: boolean) => setModal("visibleRecipeUpdateModal", open),
    [setModal]
  );
  const setIngredientVisibleModal = useCallback(
    (open: boolean) => setModal("ingredientVisibleModal", open),
    [setModal]
  );
  const setProcessingStepVisibleModal = useCallback(
    (open: boolean) => setModal("processingStepVisibleModal", open),
    [setModal]
  );
  const setProcessingStepViewModal = useCallback(
    (open: boolean) => setModal("processingStepViewModal", open),
    [setModal]
  );
  const setProcessingStepEditModal = useCallback(
    (open: boolean) => setModal("processingStepEditModal", open),
    [setModal]
  );

  const setSelectedProcess = useCallback(
    (process: Process | null) => dispatch({ type: "SET_SELECTED_PROCESS", process }),
    [dispatch]
  );
  const setDeleteIngredient = useCallback(
    (ingredient: any | null) =>
      dispatch({ type: "SET_DELETE_INGREDIENT", deleteIngredient: ingredient }),
    [dispatch]
  );
  const setIsOriginal = useCallback(
    (value: boolean) => dispatch({ type: "SET_IS_ORIGINAL", isOriginal: value }),
    [dispatch]
  );
  const setVariantId = useCallback(
    (id: string | null) => dispatch({ type: "SET_VARIANT_ID", variantId: id }),
    [dispatch]
  );
  const setDeleteVariant = useCallback(
    (value: any | null) => dispatch({ type: "SET_DELETE_VARIANT", deleteVariant: value }),
    [dispatch]
  );
  const setSelectedVariants = useCallback(
    (value: any[] | ((prev: any[]) => any[])) => {
      const nextSelectedVariants =
        typeof value === "function" ? value(selectedVariants) : value;
      dispatch({ type: "SET_SELECTED_VARIANTS", selectedVariants: nextSelectedVariants });
    },
    [dispatch, selectedVariants]
  );

  const navigateDetailsToEdit = useCallback(() => {
    dispatch({ type: "CLOSE_MODAL", modal: "processingStepViewModal" });
    dispatch({ type: "OPEN_MODAL", modal: "processingStepEditModal" });
  }, [dispatch]);

  const onButtonAction = useCallback(
    (index: number) => {
      switch (index) {
        case 0:
          dispatch({ type: "OPEN_MODAL", modal: "ingredientVisibleModal" });
          break;
        case 1:
          dispatch({ type: "OPEN_MODAL", modal: "visibleModal" });
          break;
        default:
          break;
      }
    },
    [dispatch]
  );

  const handleScrollPositionChange = useCallback(
    (atBottom: boolean) => dispatch({ type: "SET_IS_AT_BOTTOM", isAtBottom: atBottom }),
    [dispatch]
  );

  const handleToggleScroll = useCallback(() => {
    if (isAtBottom) {
      dispatch({ type: "SET_SCROLL_TO_TOP", scrollToTop: true });
      setTimeout(() => dispatch({ type: "SET_SCROLL_TO_TOP", scrollToTop: false }), 100);
    } else {
      dispatch({ type: "SET_SCROLL_TO_BOTTOM", scrollToBottom: true });
      setTimeout(() => dispatch({ type: "SET_SCROLL_TO_BOTTOM", scrollToBottom: false }), 100);
    }
  }, [dispatch, isAtBottom]);

  return {
    setVisibleModal,
    setVisibleUpdateModal,
    setVisibleRecipeUpdateModal,
    setIngredientVisibleModal,
    setProcessingStepVisibleModal,
    setProcessingStepViewModal,
    setProcessingStepEditModal,
    setSelectedProcess,
    setDeleteIngredient,
    setIsOriginal,
    setVariantId,
    setDeleteVariant,
    setSelectedVariants,
    navigateDetailsToEdit,
    onButtonAction,
    handleScrollPositionChange,
    handleToggleScroll
  };
};
